import _ from "lodash";
import HelperCollection from "utils/helper-collection";
import FetchBooking from "utils/fetch/FetchBooking";
import HelperSetting from 'utils/helper-setting'
import { settingsConstants } from 'utils/constants/settings-constants'
import HelperDate, { dateFormat } from 'utils/helper-date'

const FetchMyBooking = {
	
	currentDate: () => {
		return HelperDate.date().startOf('week');
	},
	
	pastDate: () => {
		const minDateString = HelperSetting.get( settingsConstants.CALENDAR_MIN_DATE )
		const { date: minDate } = HelperDate.split( minDateString, false );
		
		// Create from <-> till
		return {
			from: minDate.format( dateFormat.DATE ),
			till: FetchMyBooking.currentDate().format( dateFormat.DATE )
		}
	},
	
	fetchAll: ({ callbackSuccess = null, callbackError = null, callbackStart = null ,} = {} ) => {
		FetchBooking.fetch( FetchMyBooking.currentDate().format( dateFormat.DATE )+'_after_equal', {
			callbackStart: callbackStart,
			callbackError: callbackError,
			callbackSuccess: ( result ) => {
				const bookings = HelperCollection.filterWithoutGuid(
					_.get( result, ['bookings'], [] )
				);

				if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
					callbackSuccess( bookings );
				}
			}
		});
	},
	
	fetchPast: ({ callbackSuccess = null, callbackError = null, callbackStart = null ,} = {} ) => {
		FetchBooking.fetch( FetchMyBooking.pastDate(), {
			callbackStart: callbackStart,
			callbackError: callbackError,
			callbackSuccess: ( result ) => {
				const bookings = HelperCollection.filterWithoutGuid(
					_.get( result, ['bookings'], [] )
				);
				
				if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
					callbackSuccess( bookings );
				}
			}
		});
	}
}

export default FetchMyBooking
